export default __webpack_public_path__ + "static/media/metamask.164253eb.svg";